import {Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { MatSnackBar,MatSnackBarHorizontalPosition,MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CommonService } from "../shared/services/common.service";
import { IWGSharedService } from '../shared/services/shared.service';

@Component({
  selector: 'app-add-workers',
  templateUrl: './workers.component.html',
  styleUrls: ['./workers.component.scss']
})
export class AddWorkersComponent implements OnInit {

  showAddworker:boolean = false;
  first_name:string = "";
  last_name:string = "";
  email:string = "";
  phone:string = "";
  company_name:string="";
  showCompanyName = false;
  workerLabel = "";
  Hposition:MatSnackBarHorizontalPosition = "right";
  VPosition:MatSnackBarVerticalPosition = "top";
  saveWorkerLabel:string = "Save New Worker";
  @Output("added") added = new EventEmitter<any>();
  @Input("service-type-id") serviceTypeId;
  @ViewChild('company') company: ElementRef<any>;

  constructor(private toast:MatSnackBar,private service:CommonService, private sharedService: IWGSharedService) {
    sharedService.workertitlecontractor.subscribe(() => {
      next: this.handleWorkerTitleChange.bind(this)
    });
  }

  handleWorkerTitleChange() {
      this.workerLabel = 'Add New Contractor';
      this.showCompanyName = true;
      this.saveWorkerLabel = 'Save New Contractor';
  }

    ngOnChanges(changes: SimpleChanges){

        if ('serviceTypeId' in changes) {
            if (this.serviceTypeId == 3 || this.serviceTypeId == 2) {
                this.showCompanyName = true;
                this.workerLabel = 'Add New Contractor';
                this.saveWorkerLabel = 'Save New Contractor';

            }
            else {
                this.showCompanyName = false;
                this.workerLabel = 'Add New Worker';
                this.saveWorkerLabel = 'Save New Worker';
            }
        }
    }
  ngOnInit(): void {
    if (this.serviceTypeId == 3 || this.serviceTypeId == 2) {
        this.showCompanyName = true;
        this.workerLabel = 'Add New Contractor';
        this.saveWorkerLabel = 'Save New Contractor';
        
    }
    else {
        this.showCompanyName = false;
        this.workerLabel = 'Add New Worker';
        this.saveWorkerLabel = 'Save New Worker';
    }
  }
  addWorker(event){
    if (
        this.first_name == undefined ||
        this.last_name == undefined ||
        this.email == undefined ||
        this.phone == undefined
    ) {
        return;
    }
    if (
        this.first_name.trim()==null ||
        this.last_name.trim()==null ||
        this.email.trim()==null ||
        this.phone.trim() == null
        )
    {
        return;
    }
    if (
        this.first_name.trim()=='' ||
        this.last_name.trim()=='' ||
        this.email.trim()=='' ||
        this.phone.trim()==''
        )
    {
        return;
    }
    if ((this.serviceTypeId == 2 || this.serviceTypeId == 3) && (this.company_name == null || this.company_name == '')) { //To make bussiness field as manditory
       // document.getElementsByName('company_name')[0].focus();
        //document.getElementById('inputBusinessName').classList.add('ng-scope', 'md-iwgBlue-theme', 'flex', 'ng-animate', 'md-input-invalid');
        this.company.nativeElement.focus();
        return;
    }
    let props = {
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      phone: this.phone,
      company_name: this.company_name
    };

    this.service.saveWorker(props).subscribe(
      response=>{        
        if (response.data.ErrorCode == 200) {
            this.showConfirmationToast(response.data);
            this.showAddworker = false;            
            this.added.emit(response.data.Data.ID);
            this.first_name = null;
            this.last_name = null;
            this.email = null;
            this.phone = null;
            this.company_name = null;
        } else {
            console.error(response);
            this.showConfirmationToast(response.data);
        }    
      },
      err=>{
        console.log(err);
      }
    )

  }
  enable(){
    this.showAddworker = true;
  }
  cancelWorker(event){
    this.showAddworker = false;
    this.first_name = null;
    this.last_name = null;
    this.email = null;
    this.phone = null;
    this.company_name = null;
  }
  canProceed(){
    if (
        !this.first_name || this.first_name.trim() == null ||
        !this.last_name || this.last_name.trim() == null ||
        !this.email || this.email.trim() == null ||
        !this.phone || this.phone.trim() == null
    ) {
        return false;
    }
    if (
        this.first_name.trim() == '' ||
        this.last_name.trim() == '' ||
        this.email.trim() == '' ||
        this.phone.trim() == ''
    ) {
        return false;
    }
    if ((this.serviceTypeId == 2 || this.serviceTypeId == 3) && (this.company_name == null || this.company_name == '')) { 
        return false;
    }
    return true;
  }
  showConfirmationToast(response) {
    var successMessage = '';
    if (response.ErrorCode == 200) {
        successMessage = (this.serviceTypeId == 2) ? 'A new contractor has been added' : 'A new worker has been added'
    } else {
        successMessage = response.Message.Details;
    }
    this.toast.open(successMessage, "Got it", {
      duration: 2000,horizontalPosition:this.Hposition,
      verticalPosition:this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }
}
